import { useLayoutEffect } from "react";

const NAVBAR_HEIGHT = 70;
const STICKY_TOOLBAR_MIN_WIDTH = 769;

export function useEmployeesStickyTableHeader(toolbarRef, deps = []) {
  useLayoutEffect(() => {
    const toolbar = toolbarRef.current;
    if (!toolbar) return;

    const pageRoot = toolbar.closest(".employees-page");
    if (!pageRoot) return;

    const update = () => {
      const toolbarHeight = toolbar.getBoundingClientRect().height;
      const toolbarIsSticky = window.innerWidth >= STICKY_TOOLBAR_MIN_WIDTH;
      const theadTop = toolbarIsSticky
        ? NAVBAR_HEIGHT + toolbarHeight
        : NAVBAR_HEIGHT;

      pageRoot.style.setProperty("--employees-thead-top", `${theadTop}px`);
    };

    update();

    const resizeObserver =
      typeof ResizeObserver !== "undefined"
        ? new ResizeObserver(() => requestAnimationFrame(update))
        : null;

    resizeObserver?.observe(toolbar);
    window.addEventListener("resize", update);
    document.fonts?.ready?.then(update);

    return () => {
      resizeObserver?.disconnect();
      window.removeEventListener("resize", update);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [toolbarRef, ...deps]);
}
